import {
  PAY_FAILED,
  PAY_INVALID_REQUEST,
  PAY_FAILED_TRANSACTION,
  PAY_INSUFFICIENT_AMOUNT,
  PAY_INVALID_ACCOUNT_TYPE,
  PAY_INVALID_CURRENCY,
  PAY_INVALID_CUSTOMER_OPTION,
  PAY_INVALID_FLAG,
  PAY_NOT_FOUND,
  PAY_WALLET_OWNER_ID_NOT_FOUND,
  PAY_SUCCESS,
  PAY_OPERATION_NOT_PERMITTED,
  RESET_PAY,
  LOADING_PAY,
} from "../types";

const initialState = {
  isLoading: false,
  notFound: false,
  walletOwnerIdNotFound: false,
  failed: false,
  failedTransaction: false,
  invalidRequest: false,
  success: false,
  insufficientAmount: false,
  invalidCurrency: false,
  invalidFlag: false,
  invalidCustomerOption: false,
  invalidAccountType: false,
  operationNotFound: false,
  data: {},
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PAY:
      return {
        ...state,
        isLoading: true,
        notFound: false,
        walletOwnerIdNotFound: false,
        failed: false,
        failedTransaction: false,
        success: false,
        insufficientAmount: false,
        invalidRequest: false,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: false,
        data: {},
        status: "",
      };
    case PAY_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        notFound: true,
        failed: false,
        walletOwnerIdNotFound: false,
        failedTransaction: false,
        success: false,
        insufficientAmount: false,
        invalidRequest: false,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: false,
        data: action.payload,
        status: "Not found!",
      };

    case PAY_INSUFFICIENT_AMOUNT:
      return {
        ...state,
        isLoading: false,
        walletOwnerIdNotFound: false,
        notFound: false,
        failed: false,
        failedTransaction: false,
        invalidRequest: false,
        success: false,
        insufficientAmount: true,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: false,
        data: action.payload,
        status: "Insufficient Amount",
      };
    case PAY_INVALID_FLAG:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        walletOwnerIdNotFound: false,
        failed: false,
        failedTransaction: false,
        invalidRequest: false,
        success: false,
        insufficientAmount: false,
        invalidCurrency: false,
        invalidFlag: true,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: false,
        data: action.payload,
        status: "Invalid flag!",
      };
    case PAY_FAILED:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        walletOwnerIdNotFound: false,
        failed: true,
        failedTransaction: false,
        invalidRequest: false,
        success: false,
        insufficientAmount: false,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: false,
        data: action.payload,
        status: "Pay failed",
      };
    case PAY_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        walletOwnerIdNotFound: false,
        failed: false,
        invalidRequest: true,
        failedTransaction: false,
        success: false,
        insufficientAmount: false,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: false,
        data: action.payload,
        status: "Oops!, Something went wrong",
      };
    case PAY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        failed: false,
        walletOwnerIdNotFound: false,
        invalidRequest: false,
        failedTransaction: false,
        success: true,
        insufficientAmount: false,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: false,
        data: action.payload,
        status: "",
      };

    case PAY_INVALID_ACCOUNT_TYPE:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        failed: false,
        invalidRequest: false,
        walletOwnerIdNotFound: false,
        failedTransaction: false,
        success: false,
        insufficientAmount: false,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: true,
        operationNotFound: false,
        data: action.payload,
        status: "Please enter merchant contact details",
      };

    case PAY_FAILED_TRANSACTION:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        walletOwnerIdNotFound: false,
        failed: false,
        invalidRequest: false,
        failedTransaction: true,
        success: false,
        insufficientAmount: false,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: false,
        data: action.payload,
        status: "Transaction failed",
      };

    case PAY_INVALID_CURRENCY:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        failed: false,
        invalidRequest: false,
        walletOwnerIdNotFound: false,
        failedTransaction: false,
        success: false,
        insufficientAmount: false,
        invalidCurrency: true,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: false,
        data: action.payload,
        status: "Please enter valid currency!",
      };

    case PAY_INVALID_CUSTOMER_OPTION:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        walletOwnerIdNotFound: false,
        failed: false,
        invalidRequest: false,
        failedTransaction: false,
        success: false,
        insufficientAmount: false,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: true,
        invalidAccountType: false,
        operationNotFound: false,
        data: action.payload,
        status: "Invalid customer option!",
      };

    case PAY_WALLET_OWNER_ID_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        walletOwnerIdNotFound: true,
        failed: false,
        invalidRequest: false,
        failedTransaction: false,
        success: false,
        insufficientAmount: false,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: false,
        data: action.payload,
        status: "Wallet owner not found!",
      };

    case PAY_OPERATION_NOT_PERMITTED:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        walletOwnerIdNotFound: false,
        failed: false,
        invalidRequest: false,
        failedTransaction: false,
        success: false,
        insufficientAmount: false,
        invalidCurrency: false,
        invalidFlag: false,
        invalidCustomerOption: false,
        invalidAccountType: false,
        operationNotFound: true,
        data: action.payload,
        status: "Operation Not Permitted",
      };

    case RESET_PAY:
      return (state = initialState);

    default:
      return state;
  }
};
